import { render } from "./UserAuth.vue?vue&type=template&id=9ab15fea&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=9ab15fea&scoped=true&lang=css"

import exportComponent from "D:\\Users\\וינברג\\Documents\\Vue\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab15fea"]])

export default __exports__